export const Header = () => {
  return <header>Drum Machine</header>;
};
